import {
  ItemListRendererProps as BlueprintItemListRendererProps,
  renderFilteredItems as blueprintRenderFilteredItems,
} from '@blueprintjs/select';
import * as React from 'react';

import { MenuItems } from 'bones/design-system/components/select/MenuItems';
import { SelectItem } from 'bones/design-system/utils/select/types';

export type ListRendererOptions = {
  noResults: JSX.Element;
};

export const listRenderer =
  <
    SubItemType extends SelectItem | null,
    ItemType extends SelectItem<SubItemType>
  >({
    noResults,
  }: ListRendererOptions) =>
  // eslint-disable-next-line react/display-name
  (listProps: BlueprintItemListRendererProps<ItemType>) => {
    const { itemsParentRef, renderCreateItem, menuProps } = listProps;

    const createItemView = renderCreateItem();
    const maybeNoResults = createItemView != null ? null : noResults;
    const menuContent = blueprintRenderFilteredItems(listProps, maybeNoResults);

    return (
      <MenuItems
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...menuProps}
        ulRef={itemsParentRef}
      >
        {createItemView}
        {menuContent}
      </MenuItems>
    );
  };
